<template>
    <div>
        <slot :fields="fields" :values="values"></slot>
    </div>
</template>
<script>
    export default {
        props: {
            inputs: {
                type: Object,
                required: true
            },
            values: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                fields: this.inputs
            }
        }
    }
</script>